export default __webpack_public_path__ + "static/media/pause-circle-o.3146922d.svg";